import script from "./ThePagination.vue?vue&type=script&setup=true&lang=js"
export * from "./ThePagination.vue?vue&type=script&setup=true&lang=js"

import "./ThePagination.vue?vue&type=style&index=0&id=4353934b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4353934b"]])

export default __exports__